const lodash = require('lodash');

const moveAndPushDown = function moveAndPushDownCollection(collection, from, to) {
  if (!collection || !Array.isArray(collection) || collection.length < 2) {
    console.error('Invalid collection');
    return null;
  }
  if (
    !Number.isInteger(from) ||
    !Number.isInteger(to) ||
    from > collection.length ||
    to > collection.length
  ) {
    console.error('Invalid from or to');
    return collection;
  }

  try {
    if(from>to)                                                   //rearranging items from bottom to top
    {
      let lower = to;
      let higher = from;
      
      const outputCollection = lodash.cloneDeep(collection);
      let higherStop = outputCollection[higher];
      for (let x = higher; x > lower; x--) {
        outputCollection[x] = outputCollection[x - 1];
      }
      outputCollection[lower] = higherStop;
      return outputCollection;
    }
    else if(from<to)                                            //rearranging items from top to bottom
    {                                       
      let lower = from;
      let higher = to;
      
      const outputCollection = lodash.cloneDeep(collection);
      let lowerStop = outputCollection[lower];
      for (let x = lower; x < higher; x++) {
        outputCollection[x] = outputCollection[x + 1];
      }
      outputCollection[higher] = lowerStop;
      return outputCollection;
    }
    else                                                      //keep same while no rearrange
    {
      return collection;
    }
  } catch (error) {
    console.error('Failed swapping collection', error);
  }

  return null;
};

export { moveAndPushDown };
